export default "__VITE_ASSET__BQlxgQOi__"